var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promo-footer-terms"},[_c('FooterPegi',{staticClass:"promo-footer-terms__pegi"}),_c('TermsList',{staticClass:"promo-footer-terms__docs"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }